import request from '../../config/axiosConfig';
import {
  CREATE_BLOCK_ITEM,
  DELETE_BLOCK_ITEM,
  GET_BLOCK_ITEM_INFO,
  GET_LIST_BLOCK_ITEMS,
  UPDATE_BLOCK_ITEM,
} from '../../constants/apiEndPoint';

export const getListBlockItemsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_BLOCK_ITEMS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getBlockItemInfoRequest = async (data) => {
  const result = await request({
    url: GET_BLOCK_ITEM_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createBlockITemRequest = async (data) => {
  const result = await request({
    url: CREATE_BLOCK_ITEM,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateBlockItemRequest = async (data) => {
  const result = await request({
    url: UPDATE_BLOCK_ITEM,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteBlockItemRequest = async (data) => {
  const result = await request({
    url: DELETE_BLOCK_ITEM,
    method: 'POST',
    data,
  });
  return result?.data;
};
